export class CustomerMVPModel {
    isLogined = false;
    isMVP = false;
    isGetFreeTrailMVP = false;
    shippingSavings = 0;
    vipExpiredDate = new Date(1900, 1, 1);
    shippingSavingsDesc = '';
    leftMVPDays = 0;
}
export var EmailSubscribeFrequence;
(function (EmailSubscribeFrequence) {
    EmailSubscribeFrequence[EmailSubscribeFrequence["Weekly"] = 1] = "Weekly";
    EmailSubscribeFrequence[EmailSubscribeFrequence["EveryTwoWeeks"] = 2] = "EveryTwoWeeks";
    EmailSubscribeFrequence[EmailSubscribeFrequence["Monthly"] = 3] = "Monthly";
    EmailSubscribeFrequence[EmailSubscribeFrequence["Quarterly"] = 4] = "Quarterly";
})(EmailSubscribeFrequence || (EmailSubscribeFrequence = {}));
export const EmailSubscribeFrequenceList = [
    { value: EmailSubscribeFrequence.Weekly, text: "Newsletters! Sales! Flash Deals! Keep 'em coming!" },
    { value: EmailSubscribeFrequence.EveryTwoWeeks, text: "Every 2 Weeks - I don't want to miss out!" },
    { value: EmailSubscribeFrequence.Monthly, text: "Once a month - It's really all I need, but I'll change it if I want more!" },
    { value: EmailSubscribeFrequence.Quarterly, text: "Once a quarter - Distance will only bring us closer together." },
];
export var SubscribeAnyPromoStatus;
(function (SubscribeAnyPromoStatus) {
    SubscribeAnyPromoStatus[SubscribeAnyPromoStatus["No"] = 0] = "No";
    SubscribeAnyPromoStatus[SubscribeAnyPromoStatus["Yes"] = 1] = "Yes";
})(SubscribeAnyPromoStatus || (SubscribeAnyPromoStatus = {}));
export const SubscribeAnyPromoStatusList = [
    { value: SubscribeAnyPromoStatus.No, text: "No, I'll remember to reorder on my own. Also, I'll leave feedback on your website when I can." },
    { value: SubscribeAnyPromoStatus.Yes, text: "Yes, I'd like to be reminded about reordering. Also, I'd like to give feedback about my experience with AnyPromo." },
];
export var ThirdPartySubscribeStatus;
(function (ThirdPartySubscribeStatus) {
    ThirdPartySubscribeStatus[ThirdPartySubscribeStatus["Undetermined"] = -1] = "Undetermined";
    ThirdPartySubscribeStatus[ThirdPartySubscribeStatus["Unsubscribe"] = 0] = "Unsubscribe";
    ThirdPartySubscribeStatus[ThirdPartySubscribeStatus["Subscribe"] = 1] = "Subscribe";
})(ThirdPartySubscribeStatus || (ThirdPartySubscribeStatus = {}));
export class EmailPreferenceModal {
    firstName = '';
    lastName = '';
    email = '';
    emailFrequency = EmailSubscribeFrequence.Weekly;
    subscribeAnyPromoStatus = SubscribeAnyPromoStatus.Yes;
    userAgent = '';
    captchaCode = '';
    e = '';
    m = '';
}
export class BuyingGroupAccountPopUpModel {
    PopUpHtml = '';
    StrJs = '';
}
